export default __webpack_public_path__ + "static/media/CAPCourseImage.9ca4cdfd.svg";